<!-- Nincs saját <ion-content>: az admin keret görget – a beágyazott görgetők miatt három
     csúszka jelent meg (user, 2026-10-15). -->
<div class="osztaly-besorolas-gorgo">
  <div class="osztaly-besorolas-page">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Tanulók osztályba sorolása</ion-card-title>
        <ion-card-subtitle>
          Válassz osztályt, majd kezeld a névsort, a naplósorszámot és a törzslapszámot.
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <div class="toolbar">
          <ion-button
            fill="outline"
            color="primary"
            class="osztaly-valaszto-gomb"
            (click)="osztalyPickerNyitas()"
          >
            <ion-icon slot="start" name="search-outline"></ion-icon>
            <ng-container *ngIf="kivalasztottOsztaly; else nincsOsztaly">
              {{ kivalasztottOsztaly.osztaly }}
              <ng-container *ngIf="kivalasztottOsztaly.ev">&nbsp;({{ kivalasztottOsztaly.ev }})</ng-container>
            </ng-container>
            <ng-template #nincsOsztaly>Válassz osztályt…</ng-template>
          </ion-button>

          <ion-input
            label="Keresés"
            label-placement="stacked"
            fill="outline"
            placeholder="Név, oktatási azonosító, sorszám"
            [(ngModel)]="kereses"
            (ionInput)="szures()"
          ></ion-input>

          <ion-toggle [(ngModel)]="csakOsztalyTagok" (ionChange)="szures()"
                      [disabled]="csakOsztalyNelkuli">Csak osztálytagok</ion-toggle>

          <!-- Archiválás = szűrés a lezárt jogviszony alapján: az adat a helyén marad. -->
          <ion-toggle [(ngModel)]="kiiratkozottakIs" (ionChange)="szures()"
                      [disabled]="csakOsztalyNelkuli">Kiiratkozottak is</ion-toggle>

          <!-- Aki kikerült egy osztályból, azt a fenti két szűrő EGYSZERRE rejti el.
               Ez a nézet pont őket hozza elő – ilyenkor a másik kettő félreáll. -->
          <ion-toggle [(ngModel)]="csakOsztalyNelkuli" (ionChange)="szures()">
            Csak osztály nélküliek<span *ngIf="osztalyNelkuliDb"> ({{ osztalyNelkuliDb }})</span>
          </ion-toggle>

          <ion-button fill="outline" color="primary" (click)="ujOsztalyForm = !ujOsztalyForm">
            <ion-icon slot="start" name="add-circle-outline"></ion-icon>
            Új osztály
          </ion-button>

          <ion-button fill="outline" color="medium" (click)="listaNyitva = !listaNyitva">
            <ion-icon slot="start" name="clipboard-outline"></ion-icon>
            Osztályfőnökök listából
          </ion-button>
        </div>

        <!-- Tömeges betöltés: az iskola táblázatából kimásolt „osztály – ofő – helyettes"
             sorok. Előbb mindig próba, és csak a hibátlan sorok töltődnek be. -->
        <div class="of-lista" *ngIf="listaNyitva">
          <p class="of-lista-sugo">
            Soronként egy osztály, oszlopok: <b>osztály</b>, <b>osztályfőnök</b>, <b>helyettes(ek)</b> –
            táblázatból kimásolva (tabulátorral), vagy pontosvesszővel elválasztva. Több helyettes
            vesszővel. A dolgozó megadható névvel, felhasználónévvel vagy e-mail-címmel. Üres
            osztályfőnök-oszlop: az marad, ami volt; üres helyettes-oszlop: nincs helyettes.
            Tanév: {{ listaTanev }}.
          </p>
          <ion-textarea fill="outline" [autoGrow]="true" rows="5" [(ngModel)]="listaSzoveg"
                        (ionInput)="listaEredmeny = null"
                        placeholder="10/A; Szabó Zsófia; Magyarosi Attila"></ion-textarea>
          <div class="of-lista-gombok">
            <ion-button size="small" fill="outline" (click)="listaFeldolgozas(true)"
                        [disabled]="listaFut || !listaSzoveg.trim()">
              <ion-icon slot="start" name="eye-outline"></ion-icon>Próba
            </ion-button>
            <ion-button size="small" color="success" (click)="listaFeldolgozas(false)"
                        [disabled]="listaFut || !listaEredmeny?.proba || !listaEredmeny?.rendben">
              <ion-icon slot="start" name="save-outline"></ion-icon>
              Betöltés ({{ listaEredmeny?.proba ? listaEredmeny.rendben : 0 }} sor)
            </ion-button>
          </div>
          <table class="of-lista-tabla" *ngIf="listaEredmeny?.sorok?.length">
            <thead>
              <tr><th>Osztály</th><th>Osztályfőnök</th><th>Helyettes(ek)</th><th>Állapot</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of listaEredmeny.sorok" [class.hibas]="s.hibak?.length">
                <td>{{ s.osztaly }}</td>
                <td>
                  <ng-container *ngIf="s.of">{{ munkatarsNev(s.of) }}</ng-container>
                  <span *ngIf="!s.of && s.regi_of" class="halvany">(marad: {{ munkatarsNev(s.regi_of) }})</span>
                </td>
                <td>{{ s.helyettesek?.length ? '' : '–' }}<ng-container
                    *ngFor="let h of s.helyettesek; let utolso = last">{{ munkatarsNev(h) }}{{ utolso ? '' : ', ' }}</ng-container></td>
                <td>
                  <span *ngIf="!s.hibak?.length">{{ listaEredmeny.proba ? 'rendben' : 'betöltve' }}</span>
                  <span *ngIf="s.hibak?.length" class="hiba">{{ s.hibak.join('; ') }} – kihagyva</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="uj-osztaly-form" *ngIf="ujOsztalyForm">
          <ion-input label="Osztály neve" label-placement="stacked" fill="outline"
            placeholder="pl. 1.a" [(ngModel)]="ujOsztaly.osztaly"></ion-input>
          <ion-input label="Évfolyam" label-placement="stacked" fill="outline" type="number"
            placeholder="pl. 1" [(ngModel)]="ujOsztaly.evfolyam"></ion-input>
          <ion-input label="Tanév (kezdő év)" label-placement="stacked" fill="outline" type="number"
            [(ngModel)]="ujOsztaly.ev"></ion-input>
          <ion-input label="Osztályfőnök (felhasználónév)" label-placement="stacked" fill="outline"
            placeholder="pl. juhasz.henriett" [(ngModel)]="ujOsztaly.of"></ion-input>
          <ion-button color="success" (click)="osztalyLetrehozas()" [disabled]="osztalyLetrehozasFolyamatban">
            <ion-icon slot="start" name="save-outline"></ion-icon>
            Létrehozás
          </ion-button>
        </div>

        <!-- Osztály adatai: az átnevezés biztonságos, mert mindenhol az azonosító
             hivatkozik az osztályra (jogviszony, órarend, tantárgyfelosztás). -->
        <div class="osztaly-adatok" *ngIf="kivalasztottOsztaly">
          <ion-input label="Osztály neve" label-placement="stacked" fill="outline"
                     [(ngModel)]="ujNev" placeholder="pl. 1.a"></ion-input>
          <ion-input label="Évfolyam" label-placement="stacked" fill="outline" type="number"
                     [(ngModel)]="ujEvfolyam"></ion-input>
          <ion-input label="Osztályfőnök (felhasználónév)" label-placement="stacked" fill="outline"
                     [(ngModel)]="ujOf" placeholder="pl. juhasz.henriett"></ion-input>
          <ion-button size="small" color="primary" (click)="osztalyAdatMentes()" [disabled]="nevMentes">
            <ion-icon slot="start" name="create-outline"></ion-icon>Mentés
          </ion-button>
          <ion-button size="small" fill="clear" color="danger" (click)="osztalyTorles()">
            <ion-icon slot="start" name="trash-outline"></ion-icon>Osztály törlése
          </ion-button>
          <!-- A helyettes ugyanúgy igazol és látja az Osztályfőnök menüt, mint az ofő –
               de a bizonyítványon és a törzslapon az osztályfőnök neve áll. -->
          <div class="helyettesek">
            <span class="helyettes-cim">Osztályfőnök-helyettes:</span>
            <ion-chip *ngFor="let h of helyettesek" outline>
              <ion-label>{{ h.nev }}</ion-label>
              <ion-icon name="close-circle" (click)="helyettesLevetele(h.allomany)"
                        [attr.aria-label]="h.nev + ' levétele'"></ion-icon>
            </ion-chip>
            <span *ngIf="!helyettesek.length" class="helyettes-nincs">nincs kijelölve</span>
            <ion-button size="small" fill="outline" (click)="helyettesValasztas()" [disabled]="helyettesMentes">
              <ion-icon slot="start" name="person-add-outline"></ion-icon>Helyettes kijelölése
            </ion-button>
          </div>
          <ion-note color="medium">
            Törölni csak üres osztályt lehet (nincs hozzá jogviszony, óra, tantárgyfelosztás).
            Csak a(z) {{ kivalasztottOsztaly.ev }}. tanév osztályát módosítja – a korábbi tanévek
            osztályai külön sorok, azok változatlanok maradnak. A névsor és az órarend megmarad.
          </ion-note>
        </div>

        <div class="actions" *ngIf="kivalasztottOsztaly">
          <ion-button color="primary" fill="outline" (click)="osszesLathatoKijelolese(true)">
            Láthatók kijelölése
          </ion-button>
          <ion-button color="medium" fill="outline" (click)="osszesLathatoKijelolese(false)">
            Láthatók törlése
          </ion-button>
          <ion-button color="success" (click)="mentesInditasa()" [disabled]="mentes">
            <ion-icon slot="start" name="save-outline"></ion-icon>
            Mentés ({{ kijeloltDb }})
          </ion-button>
        </div>

        <ion-progress-bar type="indeterminate" *ngIf="betoltes"></ion-progress-bar>

        <div class="empty-state" *ngIf="!betoltes && !kivalasztottOsztaly">
          Válassz egy osztályt a névsor szerkesztéséhez.
        </div>

        <div class="student-table-wrap" *ngIf="kivalasztottOsztaly">
          <table class="student-table">
            <thead>
              <tr>
                <th class="check-col">Tag</th>
                <th>Tanuló</th>
                <th>Oktatási azonosító</th>
                <th>Aktuális osztály</th>
                <th>Naplósorszám</th>
                <th>Törzslapszám</th>
                <th title="A beírási napló sorszáma a tanulóé: tanévről tanévre ugyanaz marad">Beírási napló sorszám</th>
                <th>Záradékok</th>
                <th>Jogviszony</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tanulo of szurtTanulok" [class.not-member]="!tanulo.selected">
                <td class="check-col">
                  <ion-checkbox [(ngModel)]="tanulo.selected"></ion-checkbox>
                </td>
                <td>
                  <strong>{{ tanulo.full_name || 'Névtelen tanuló' }}</strong>
                </td>
                <td>{{ tanulo.oktazon }}</td>
                <td>{{ tanulo.aktualis_osztaly || '-' }}</td>
                <td>
                  <ion-input
                    type="text"
                    fill="outline"
                    class="small-input"
                    [(ngModel)]="tanulo.naplosorszam"
                    [disabled]="!tanulo.selected"
                  ></ion-input>
                </td>
                <td>
                  <ion-input
                    type="text"
                    fill="outline"
                    class="small-input"
                    [(ngModel)]="tanulo.torzslapszam"
                    [disabled]="!tanulo.selected"
                  ></ion-input>
                </td>
                <td>
                  <ion-input
                    type="text"
                    fill="outline"
                    class="small-input"
                    [(ngModel)]="tanulo.beirasi_naplo_sorszam"
                    [disabled]="!tanulo.selected"
                  ></ion-input>
                </td>
                <td>
                  <ion-button size="small" fill="outline" (click)="zaradekokMegnyitasa(tanulo)">
                    <ion-icon slot="start" name="document-text-outline"></ion-icon>
                    Záradékok
                  </ion-button>
                </td>
                <td>
                  <!-- A kiiratkozás záradékkal együtt, egy tranzakcióban zárja le a jogviszonyt. -->
                  <ion-button size="small" fill="clear" color="danger" *ngIf="!tanulo.kiiratkozott"
                              (click)="kiiratkozas(tanulo)">
                    <ion-icon slot="start" name="exit-outline"></ion-icon>Kiiratkozás
                  </ion-button>
                  <ion-chip *ngIf="tanulo.kiiratkozott" color="medium" outline>
                    <ion-label>Kiiratkozott</ion-label>
                  </ion-chip>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="empty-state" *ngIf="!betoltes && szurtTanulok.length === 0">
            <span *ngIf="csakOsztalyNelkuli">Most minden tanulónak van osztálya.</span>
            <span *ngIf="!csakOsztalyNelkuli">Nincs a szűrésnek megfelelő tanuló.</span>
          </div>

          <!-- A SZŰRÉS NE LEGYEN NÉMA. Üres (vagy hiányos) listánál meg kell mondani,
               hogy nincs ilyen tanuló, vagy csak nem látszik – és egy kattintással
               elő is hozható. Enélkül úgy tűnt, a tanuló „eltűnt a rendszerből". -->
          <div class="szuro-jelzes" *ngIf="!betoltes && (rejtettNemTag || rejtettKiiratkozott)">
            <ion-icon name="eye-off-outline"></ion-icon>
            <span>
              A szűrés elrejt
              <b *ngIf="rejtettNemTag">{{ rejtettNemTag }}</b><span *ngIf="rejtettNemTag"> tanulót, aki nincs ebben az osztályban</span><span
                *ngIf="rejtettNemTag && rejtettKiiratkozott">, és </span><b
                *ngIf="rejtettKiiratkozott">{{ rejtettKiiratkozott }}</b><span *ngIf="rejtettKiiratkozott"> kiiratkozottat</span>.
            </span>
            <ion-button size="small" fill="clear" (click)="mindenkitMutat()">Mindet mutasd</ion-button>
            <ion-button size="small" fill="clear" *ngIf="osztalyNelkuliDb"
                        (click)="osztalyNelkulieketMutat()">
              Osztály nélküliek ({{ osztalyNelkuliDb }})
            </ion-button>
          </div>
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</div>
